import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react'

import QRCode from 'qrcode'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const QrLinkModal = observer(({ distributeStore }) => {
    const [qrCode, setQrCode] = useState(null)

    const generateQR = async () => {
        const dataUrl = await QRCode.toDataURL(distributeStore.qrLink, { width: 1080 })
        setQrCode(dataUrl)
    }

    useEffect(() => {
        if (distributeStore.qrLink) {
            generateQR()
        }
        return (() => {
            setQrCode(null)
        })
    }, [distributeStore.qrLink])

    return (
        <Modal
            show={distributeStore.showQrModal}
            onClose={distributeStore.closeQrModal}
        >
            {qrCode && (
                <img style={{ display: 'block', width: '100%' }} id="qrLink" src={qrCode} alt="" />
            )}

            <ModalFooter cssClass="campaign-links-modal-buttons">
                <Button
                    cssClass="campaign-links-modal-button tertiary"
                    onClick={distributeStore.closeQrModal}
                >
                    {i18n.t('close')}
                </Button>

                <Button
                    cssClass="campaign-links-modal-button primary"
                    onClick={distributeStore.downloadQR}
                >
                    {i18n.t('download')}
                </Button>
            </ModalFooter>
        </Modal>
    )
})

export default QrLinkModal
